export function nowIso(): string {
  return new Date().toISOString();
}

export function toUnixMs(value: string | number | Date): number {
  if (value instanceof Date) return value.getTime();
  if (typeof value === 'number') return value;
  const parsed = Date.parse(value);
  return Number.isFinite(parsed) ? parsed : Date.now();
}

export function durationMs(startMs: number, endMs = Date.now()): number {
  return Math.max(0, endMs - startMs);
}
